(() => {
  const imageSelector = [
    '.hanfi-home__product-media img',
    '.hanfi-home__trend-media img',
    '.hanfi-home__occasion-media img',
    '.hanfi-home__weave-feature img',
    '.hanfi-home__weave-tile img',
    '.hanfi-home__watch-media img',
    '.hanfi-home__story-media img',
    '.hanfi-home__ugc-card img',
    '.hanfi-module__image-card img',
    '.hanfi-module__weave img',
    '.hanfi-module__fabrics img',
    '.hanfi-module__ugc img',
    '.hanfi-product-card__media img',
    '.hanfi-more-option__media img',
    '.card-gallery img',
    '.product-media-gallery img'
  ].join(',');

  const paintContainerSelector = [
    '.hanfi-home__product-media',
    '.hanfi-home__trend-media',
    '.hanfi-home__occasion-media',
    '.hanfi-home__weave-feature',
    '.hanfi-home__weave-tile',
    '.hanfi-home__watch-media',
    '.hanfi-module__image-card',
    '.hanfi-module__weave',
    '.hanfi-module__fabrics > a',
    '.hanfi-product-card__media',
    '.hanfi-more-option__media',
    '.card-gallery',
    '.product-media-gallery'
  ].join(',');

  const markReady = (img) => {
    img.classList.add('hanfi-image-ready');
    img.closest(paintContainerSelector)?.classList.add('hanfi-media-ready');
  };

  const watchImage = (img) => {
    if (!(img instanceof HTMLImageElement) || img.dataset.hanfiWatched === 'true') return;
    img.dataset.hanfiWatched = 'true';
    img.decoding = 'async';

    if (img.complete) {
      markReady(img);
      return;
    }

    img.addEventListener('load', () => markReady(img), { once: true });
    img.addEventListener('error', () => markReady(img), { once: true });
  };

  const watchImagesIn = (root = document) => {
    root.querySelectorAll?.(imageSelector).forEach(watchImage);
  };

  const init = () => {
    document.documentElement.classList.add('hanfi-mobile-render-safe');
    watchImagesIn(document);

    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        mutation.addedNodes.forEach((node) => {
          if (!(node instanceof Element)) return;
          if (node.matches?.(imageSelector)) watchImage(node);
          watchImagesIn(node);
        });
      });
    });

    observer.observe(document.documentElement, { childList: true, subtree: true });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
